import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchTiers = async () => {
  const { data } = await axios.get(`${API}/tiers`);
  return data;
};

export const fetchPreorderStats = async () => {
  const { data } = await axios.get(`${API}/preorders/stats`);
  return data;
};

export const createReservation = async (payload) => {
  const { data } = await axios.post(`${API}/reservations`, payload);
  return data;
};

export const createCheckout = async (payload) => {
  const { data } = await axios.post(`${API}/checkout/session`, payload);
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/checkout/status/${sessionId}`);
  return data;
};

export const subscribeEmail = async (email) => {
  const { data } = await axios.post(`${API}/subscribe`, { email });
  return data;
};

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { email, password });
  return data;
};

export const adminGetData = async (token) => {
  const { data } = await axios.get(`${API}/admin/data`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const adminExportUrl = (kind) => `${API}/admin/export?kind=${kind}`;
